import { gravComponentSchema } from '../deep-form-grav';
import { RevolverMatrixProps, defaults, TableEntry } from '@/components/ui/RevolverMatrix.ts';

const { s, l, bl, toExport } = gravComponentSchema<RevolverMatrixProps>({
  title: 'RevolverMatrix',
  link: '',
  text: text(),
},
  defaults,
);

export default toExport;

// ===== Basic Settings =====
s.add('treeId').as(l.clone('selectTree')).col(3);
s.add('width').input('dictionary').data(['2', '3', '4']).title('Matrix width').col(3)
  .convert((v) => v ? Number(v) : 2);
s.add('titleField').input('text').title('Title field').col(3);
s.add('subtitleField').input('text').title('Subtitle field').col(3);

s.add('titleFieldMax').as(bl.clone('number')).title('Title max length').col(3);
s.add('subtitleFieldMax').as(bl.clone('number')).title('Subtitle max length').col(3);

s.add('noTableFoundText').input('vtext').title('No table found text').col(6)
  .props({ clearable: true });

// Tables mapping - array of table entries
s.add('tables').input('dlist').data(
  s.spawn<TableEntry>().input('dform').data([
    s.spawn<number>('treeId').input('text').props({ class: 'mr-md-2', density: 'compact', dfTitleInside: true, hideDetails: false }).title('Tree ID').mandatory().col(3)
      .convert((v: any) => v === '' || v === null || v === undefined ? 0 : Number(v))
      .item(),
    s.spawn<number>('offset').input('text').props({ class: 'mr-md-2', density: 'compact', dfTitleInside: true, hideDetails: false }).title('Offset').mandatory().col(3)
      .convert((v: any) => v === '' || v === null || v === undefined ? 0 : Number(v))
      .item(),
    s.spawn<string>('name').input('text').props({ density: 'compact', dfTitleInside: true, hideDetails: false }).title('Table Name').mandatory().col(6).item(),
  ])
    .init(() => ({ treeId: 0, offset: 0, name: '' }))
    .props({ style: 'border: 1px solid #ccc; padding: 10px; margin: 5px; border-radius: 5px;' })
    .item()
)
  .title('Tables mapping')
  .desc('Define which positions in the tree should be shown as tables. Order matters!')
  .col(12);

s.add('properties').as(l.clone('mandatoryProperties')).col(6);
s.add('popupProperties').as(l.clone('popupProperties')).col(6);
s.add('headerTitles').as(l.clone('headerTitles')).col(12);


// ===== Wrapper Styles =====
s.add('backgroundColor').input('color').title('Background color').col(3);
s.add('loaderColor').input('color').title('Loader color').col(3);
s.add('tabsSliderColor').input('color').title('Tabs slider color').col(3);
s.add('tableChipColor').input('color').title('Table chip color').col(3);
s.add('tabsWrapperClass').input('text').title('Tabs wrapper class').col(3);
s.add('tabsClass').input('text').title('Tabs class').col(3);
s.add('matrixWrapperClass').input('text').title('Matrix wrapper class').col(6);
s.add('contentWrapperClass').input('text').title('Content wrapper class').col(6);

// ===== Card Styles =====
s.add('cardBackgroundColor').input('color').title('Card background').col(3);
s.add('emptySlotColor').input('color').title('Empty slot color').col(3);
s.add('cardTitleColor').input('color').title('Card title color').col(3);
s.add('cardSubtitleColor').input('color').title('Card subtitle color').col(3);
s.add('arrowColor').input('color').title('Arrow color').col(3);

s.add('cardClass').input('text').title('Card class').col(6);
s.add('emptyCardClass').input('text').title('Empty card class').col(6);

// ===== Avatar Sizes =====
s.add('avatarSizeLevel0').as(bl.clone('number')).title('Avatar size level 0').col(4);
s.add('avatarSizeLevel1').as(bl.clone('number')).title('Avatar size level 1').col(4);
s.add('avatarSizeLevel2').as(bl.clone('number')).title('Avatar size level 2').col(4);

// ===== Empty Slot Behavior =====
s.add('forceMiniCards').input('boolean').title('Force mini cards for level 2').col(4);
s.add('showEmptyIcon').input('boolean').title('Show icon for empty slots').col(4);
s.add('emptyText').input('text').title('Custom empty text').col(4);

// ===== Editable Properties (for spillover) =====
s.add('editableProperties').input('dlist')
  .data(
    l.clone('propertyMarketing')
    .props({ hideDetails: true })
    .mandatory().item(),
  )
  .title('Editable Marketing Properties')
  .col(6);
s.add('editPermission').input('dictionary').data(['self', 'all', 'none'])
  .title('Edit permission')
  .col(3);

function text() {
  return `
<b>UI Component: Revolver Matrix</b>
This component displays a matrix tree structure with configurable width.
The matrix shows 3 levels: root user, level 1 (width users), and level 2 (width² users).

<b>Matrix Width</b>
Configure how many children each user has in the matrix.

<b>Display Settings</b>
Configure colors, avatar sizes, and custom classes for styling the matrix cards.

`;
}

